import React from 'react';
import PageLayout from "../components/page-layout";

export default function Roles() {

    return (
        <PageLayout pageTitle="مدیریت نقش‌ها">

        </PageLayout>
    );
}

